/* eslint max-len: 0 */
import React, { Component } from 'react';
import rp from 'request-promise';
import { Segment, Grid, Header, Message, Loader } from 'semantic-ui-react';

import PageWrap from './PageWrap';
import { firebase } from '../firebase';
import DatePicker from './DatePicker';
import WebPropertiesTable from './WebPropertiesTable';
import withAuthorization from '../withAuthorization';

class WebProperties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoading: null,
      data: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(start, end) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (new Date(start) > today || new Date(end) > today) {
      this.setState({ error: 'Cannot report on future date' });
    } else {
      this.setState({
        error: null,
        isLoading: true,
        data: null,
      });
      // Get User ID token
      firebase.auth.currentUser
        .getIdToken(/* forceRefresh */ true)
        .then(token => {
          // Request analytics data from server
          rp({
            uri: 'https://api.twr360.net/web-properties',
            qs: { start, end },
            headers: { authorization: token },
            json: true,
          })
            .then(res => {
              this.setState({ isLoading: false, data: res });
            })
            .catch(() => {
              this.setState({
                isLoading: false,
                error:
                  'Error loading data. Please check your internet connection or reload the page.',
              });
            });
        })
        .catch(() => {
          this.setState({
            isLoading: false,
            error: 'Error loading information from Google Analytics',
          });
        });
    }
  }

  render() {
    let totalSessions = 0;
    let totalUsers = 0;
    if (this.state.data) {
      // eslint-disable-next-line
      this.state.data.map(property => {
        if (property.sessions !== 'Missing Permissions') {
          totalSessions += Number(property.sessions);
        }
        if (property.users !== 'Missing Permissions') {
          totalUsers += Number(property.users);
        }
      });
    }
    return (
      <PageWrap>
        <Grid style={{ height: '100%' }} verticalAlign="middle" padded>
          <Grid.Column>
            <Segment padded>
              <Header as="h1" color="blue" style={{ marginBottom: '1.5em' }}>
                TWR Web Properties
              </Header>
              <Segment style={{ marginBottom: '3em' }}>
                <Header as="h3">Select Date Range</Header>
                <DatePicker
                  handleSubmit={this.handleSubmit}
                  loading={this.state.isLoading}
                />
                {this.state.error ? (
                  <Message error>{this.state.error}</Message>
                ) : null}
              </Segment>
              <Loader
                active={this.state.isLoading && !this.state.error}
                inline="centered"
              >
                <p>Loading...</p>
                <p>This might take a little longer on the first request</p>
              </Loader>
              {this.state.data ? (
                <WebPropertiesTable
                  data={this.state.data}
                  users={totalUsers}
                  sessions={totalSessions}
                />
              ) : null}
            </Segment>
          </Grid.Column>
        </Grid>
      </PageWrap>
    );
  }
}

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(WebProperties);



// WEBPACK FOOTER //
// ./src/components/WebProperties.jsx